// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Vuex from 'vuex'
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Tabs, Tab } from 'vue-tabs-component';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueClipboard from 'vue-clipboard2'
import * as VueGoogleMaps from 'vue2-google-maps';
import Geocoder from "@pderas/vue2-geocoder";
import tr from '@/services/localize.js';
import LoadScript from 'vue-plugin-load-script';
import AudioVisual from 'vue-audio-visual'
import VueMobileDetection from "vue-mobile-detection";
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.use(Vuex);
const swoptions = {
  confirmButtonColor: '#3085d6',
};
Vue.use(VueSweetalert2, swoptions);
Vue.use(vue2Dropzone);
Vue.use(VueClipboard)
Vue.use(LoadScript);
Vue.use(AudioVisual);
Vue.use(VueMobileDetection);
Vue.use(VueGoogleMaps);
/*, {
  load: {
    //    key: 'AIzaSyB8Lfw6x5Q-l9RBjIBgIwduqQ7a1GZLir4',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  }
});
*/
Vue.use(Geocoder, {
  defaultCountryCode: null, // e.g. 'CA'
  defaultLanguage: null, // e.g. 'en'
  defaultMode: 'address', // or 'lat-lng'
  //  googleMapsApiKey: 'AIzaSyB8Lfw6x5Q-l9RBjIBgIwduqQ7a1GZLir4'
});
import { VuePlugin } from 'vuera'
import { config } from 'vuera'
Vue.use(VuePlugin)

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.config.ignoredElements = ['m1'];
Vue.prototype.$branded = true;
Vue.config.productionTip = false;
Vue.prototype.$tr = tr;
export const globalStore = new Vue({
  data: {
    $gather: false
  }
})
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
